export default __webpack_public_path__ + "static/media/devdao.40222d29.svg";